import PortalRoleTemplateWithLnksTypes from "../../../types/portalTemplateTypes/PortalRoleTemplateWithLnksTypes"

const PortalRoleTempateWithPortalRoleLnksBoilerplate: PortalRoleTemplateWithLnksTypes = {
    Template: {
        RoleTemplateId: 0,
        Name: null,
        Description: null,
        IsProtected: false,
        CreatedBy: null,
        CreatedDateUTC: null,
        ModifiedBy: null,
        ModifyDateUTC: null,
        DeletedBy: null,
        DeletedDateUTC: null,
        DisabledBy: null,
        DisabledDateUTC: null
    },
    RoleTemplatePortalRoleLnk: []
}

export default PortalRoleTempateWithPortalRoleLnksBoilerplate